/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_2_QInputs */

const en_control_faq_2_q = /** @type {(inputs: Control_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the Build Planner require an account?`)
};

const zh_control_faq_2_q = /** @type {(inputs: Control_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配装规划器需要账号吗？`)
};

/**
* | output |
* | --- |
* | "Does the Build Planner require an account?" |
*
* @param {Control_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_2_q = /** @type {((inputs?: Control_Faq_2_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_2_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_2_q(inputs)
	return zh_control_faq_2_q(inputs)
});
export { control_faq_2_q as "control.faq.2.q" }